// extracted by mini-css-extract-plugin
export default {"flex-center":"fact_flex-center__qGyuR","fact":"fact_fact__mT3jj","flex-vertical-center":"fact_flex-vertical-center__AQ+mJ"};